/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createMuiTheme, ThemeProvider, MuiThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography } from '@material-ui/core'
import lightBlue from '@material-ui/core/colors/lightBlue';


const styles = theme => ({
    text_field : {
        width : '30%',
    },

    title: {
        fontSize: 14,
      },
      pos: {
        marginBottom: 12,
      },

      divider: {
          margin: "8px 0px"
      },

      modules: {
          marginRight: "12px",
          
      }
})

const blueTheme = createMuiTheme({ 
    palette: { 
        primary: {
            main: lightBlue[600]
        } 
    },
    typography: {
        useNextVariants: true,
        h6: {
            fontSize: '0.95rem',
            lineHeight: 1.3
        },
        body2Next: {
            fontSize: "0.75rem"
        }
    }
})


class TicketResult extends Component {
    state = {
        
    }

    componentWillMount(){

    }


    getLabelsAndValues = ( resultObj, compareDisplayObj ) => {
        let isCompareObjArr = Array.isArray(compareDisplayObj)
        if(isCompareObjArr){
            let evaluatedArr = [];
            compareDisplayObj.map((element) => {
                let evalObj = this.getEvaluatedObj(resultObj, element)
                evaluatedArr.push(evalObj)     
            })

            evaluatedArr = evaluatedArr.filter(function( element ) {

                return element !== undefined;
            });
            return evaluatedArr
        } else {
            let evaluated = this.getEvaluatedObj( resultObj, compareDisplayObj)
            return evaluated
        } 
        
       
    }


    getEvaluatedObj = ( obj, compareDisplayObj ) => {
       let evaluatedObj;
        let resultKeys = Object.keys(obj);
        let resultValues = Object.values(obj);

        for( let i = 0; i < resultKeys.length ; i++){
            if(typeof resultValues[i] === 'object'){
               return this.getEvaluatedObj(resultValues[i], compareDisplayObj)
            } else {
                if( resultKeys[i] === compareDisplayObj.key){
                    let value = resultValues[i]
                    evaluatedObj =  { value : value, label: compareDisplayObj.label}
                    break;
                }
            }
        } 
        return evaluatedObj;
    }


    renderTitle = () => {
        let { result } = this.props.config;
        let { issue } = this.props.config.displayLabels;
        let evaluatedObj = this.getLabelsAndValues(result, issue );

        console.log("Eval obj")
        console.log(evaluatedObj.value)
        
        return (
            <Typography > { evaluatedObj.value }</Typography>
        )
        
    }
    

   
    render() {  
        const { classes } = this.props
        return (
            <MuiThemeProvider theme={blueTheme}>
                <Paper>

                    { this.renderTitle() }
                </Paper>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(styles)(TicketResult);